var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"groups-view"},[_vm._v(" groups "),_c('GroupEdit'),_c('GroupList')],1)}
var staticRenderFns = []

export { render, staticRenderFns }